module.exports = __webpack_public_path__ + "img/credit.f74d1352.png";